export const reports = {
  reports: 'Informes',
  paymentHistoryError:
    'La consulta del historial de operaciones está limitada a 7 días. Por favor, especifique un período correcto.',
};
